import type { MouseEvent } from "react";

import { connect } from "react-redux";

import { colorsPalettes } from "@similarweb/styles";

import { allTrackers } from "app/services/track/track";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const LeadingSiteInner = (props: FixmeType) => {
    const { value, row, params } = props;

    const coreWebsiteCellProps = {
        domain: value,
        icon: row.favicon,
        target: "_self",
        internalLink: proNavigator.href("digitalsuite_website_websiteperformance", {
            ...params,
            key: value,
            country: params.country,
            duration: params.duration,
            webSource: params.webSource,
            isWWW: params.includeSubDomains ? "*" : "-",
        }),
        trackInternalLink: (e: MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
            allTrackers.trackEvent("Internal Link", "click", `Table/${value}`);
        },
        externalLink: `http://${value}`,
        trackExternalLink: (e: MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
            allTrackers.trackEvent("External Link", "click", `Table/${value}`);
        },
        hideTrackButton: true,
    };

    return value && value !== "grid.upgrade" ? (
        <CoreWebsiteCell {...coreWebsiteCellProps} />
    ) : (
        <div style={{ color: colorsPalettes.carbon[500] }}>N/A</div>
    );
};

const mapStateToProps = (props: FixmeType) => {
    const { routing } = props;
    const { params } = routing;
    return {
        params: {
            ...params,
        },
    };
};

export const LeadingSite = connect(mapStateToProps)(LeadingSiteInner);
